import getResourceTokenAuthInfoBarStore, { getResourceTokenAuthInfoBarStoreMap, } from "../store/resourceTokenAuthInfoBarStore";
import { getResourceTokenAuthInfoBarRequestKey, type ResourceTokenAuthInfoBarRequest, } from "../utils/getResourceTokenAuthInfoBarRequestKey";
import { getIndexerValueForMailboxInfo } from "owa-client-types";
import { mutatorAction } from "satcheljs";

export const showResourceTokenAuthInfoBarMutator: (request: ResourceTokenAuthInfoBarRequest) => void = mutatorAction("showResourceTokenAuthInfoBar", request => {
    const storedRequest = {
        ...request,
        requestKey: getResourceTokenAuthInfoBarRequestKey(request),
    };
    const state = getResourceTokenAuthInfoBarStore(request.mailboxInfo);
    if (state) {
        state.request = storedRequest;
    }
    else {
        const accountKey = getIndexerValueForMailboxInfo(request.mailboxInfo);
        getResourceTokenAuthInfoBarStoreMap().storeMap.set(accountKey, {
            request: storedRequest,
        });
    }
});

export const clearResourceTokenAuthInfoBarMutator: (mailboxInfo: ResourceTokenAuthInfoBarRequest["mailboxInfo"], requestKey: string) => void = mutatorAction("clearResourceTokenAuthInfoBar", (mailboxInfo, requestKey) => {
    const store = getResourceTokenAuthInfoBarStore(mailboxInfo);
    if (store?.request?.requestKey === requestKey) {
        store.request = undefined;
    }
});
